import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const MessageManagementForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        image: editData?.image || '',
        designation: editData?.designation || '',
        message: editData?.message || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        console.log("formValue ", formValue);
        if (apiHandler) {
            return apiHandler(formValue);
        }
        
        console.log("formValue ", formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Image' required />

                <ReactInput name='image' type='file' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Designation' required />

                <ReactInput name='designation' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Message' required />

                <ReactInput name='message' as='textarea' rows={6} />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default MessageManagementForm;
